import React, { Component } from 'react';
import { connect } from 'react-redux';
// import LaddaButton, { ZOOM_IN } from 'react-ladda';
import Select from 'react-select';
import { Button, Icon } from 'antd';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr'
import * as actionCreators from '../../../../actions/customer';

@connect(
  state => ({ customers: state.get('Customer') }),
  dispatch => ({ customerAction: bindActionCreators(actionCreators, dispatch) })
)
export default class RegisterCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  // 设置用户类型
  setType = (value) => { this.setState({ typecode: value }) }
  typein = field => (e) => {
    this.setState({ [field]: e.target.value });
  }
  submit = () => {
    const { customerAction } = this.props;
    const { code, name, typecode } = this.state;
    console.log(typecode.typecode);
    if (code && name && typecode) {
      const params = {
        code: code,
        name: name,
        typecode: typecode && typecode.typecode
      }
      customerAction.fetchAddCustomer(params)
        .then(() => {
          const { customers } = this.props;
          const data = customers.get('data');
          if (data.get('success')) {
            this.setState({ code: null, typecode: null, name: null })
            toastr.success(data.get('message'));
          } else {
            toastr.error('错误信息', data.get('message'));
          }
        })
        .catch(() => { })
    } else {
      toastr.error('错误信息', '请输入经销商信息！');
    }
  }
  render() {
    const { typecode } = this.state;
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="4">{''}</Col>
            <Col md="4">
              <h2 style={{ marginBottom: '60px' }}>迪乐扫扫-添加经销商</h2>
              <p className="text-muted">{' '}</p>
              <div className="input-group mb-2">
                <span className="input-group-addon"><Icon type="user" /></span>
                <input type="text" className="form-control" onChange={this.typein('code')} placeholder="经销商code" />
              </div>
              <div className="input-group mb-2">
                <span className="input-group-addon"><Icon type="contacts" /></span>
                <input type="text" className="form-control" onChange={this.typein('name')} placeholder="经销商名称" />
              </div>
              <div className="input-group mb-2">
                <span className="input-group-addon"><Icon type="code-o" /></span>
                <Select
                  className="form-control"
                  placeholder="选择经销商类型"
                  labelKey="typecode"
                  // labelKey=" "
                  valueKey="typecode"
                  value={typecode || ''}
                  options={[{ typecode: 'dealer' }, { typecode: 'audit' }]}

                  onChange={e => this.setType(e)}
                />
              </div>
              <div className="p-1">
                <div className="row">
                  <Button className="btn btn-block btn-primary" onClick={this.submit}><span>新增</span></Button>
                </div>
              </div>
            </Col>
          </Row>
        </CardBlock>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/App/Customer/RegisterCustomer/index.js